module.exports = __webpack_public_path__ + "static/media/dj.5d918cc7.svg";